'use strict';

import * as domUtils from '../util/dom';
var Debug = require('../util/debug')('keyboardNav');

var NAMESPACE = 'keyboard-nav';

module.exports = {
	namespace: NAMESPACE,
	create: function (api) {
		var _isPlaying = false,
			_captionsVisible = false;

		function _handleKeyUp(event) {
			var keyName = domUtils.getKeyFromKeyEvent(event),
				_eventHandled = true;
			Debug('event: ' + keyName + ' (isPlaying: ' + _isPlaying + ')');
			switch (keyName) {
				case 'enter':
				case 'space':
					if (_isPlaying) {
						api.pause();
					} else {
						api.play();
					}
					break;
				case 'digit1':
				case 'digit2':
				case 'digit3':
				case 'digit4':
				case 'digit5':
				case 'digit6':
				case 'digit7':
				case 'digit8':
				case 'digit9':
					var duration = api.getDuration();
					if (duration) {
						var seekTo = duration * parseInt(keyName.replace(/digit/, ''), 10) / 10;
						api.seek(seekTo);
					}
					break;
				case 'digit0':
				case 'home':
					api.seek(1);
					break;
				case 'end':
					api.seek(api.getDuration() - 2);
					break;
				case 'keym':
					api.mute(!api.isMuted());
					break;
				case 'keyc':
					_captionsVisible = !_captionsVisible;
					api.showCaptions(_captionsVisible, true);
					break;
				case 'keyf':
					domUtils.toggleVideoFullscreen(api);
					break;
				case 'tab':
					break;
				default:
					_eventHandled = false;
					break;
			}

			if (_eventHandled) {
				api.fire('showControls', { shouldShow: true });
				event.preventDefault();
				event.stopPropagation();
			}

			return !_eventHandled;
		}

		function _handleKeyDown(e) {
			var keyName = domUtils.getKeyFromKeyEvent(e);

			if (keyName === 'space') {
				e.preventDefault();
				e.stopPropagation();

				return true;
			}

			return false;
		}

		domUtils.addEvents(api.element(), 'keyup', _handleKeyUp, NAMESPACE);
		domUtils.addEvents(api.element(), 'keydown', _handleKeyDown, NAMESPACE);
		api.on(NAMESPACE + '.playing', function () {
			_isPlaying = true;
		});
		var notPlaying = function () {
			_isPlaying = false;
		};
		api.on(NAMESPACE + '.pause', notPlaying);
		api.on(NAMESPACE + '.error', notPlaying);
		api.on(NAMESPACE + '.buffering', notPlaying);

		api.on(NAMESPACE + '.captionsvisible', function (event) {
			Debug('setting captionsvisible to ' + event.detail.shouldShow);
			_captionsVisible = event.detail.shouldShow;
		});
	},
	destroy: function (api) {
		var element = api.element();

		if (element) {
			domUtils.removeEvents(api.element(), 'keyup', NAMESPACE);
			domUtils.removeEvents(api.element(), 'keydown', NAMESPACE);
		}
		api.off(NAMESPACE + '.playing');
		api.off(NAMESPACE + '.pause');
		api.off(NAMESPACE + '.error');
		api.off(NAMESPACE + '.buffering');
		api.off(NAMESPACE + '.seeking');
		api.off(NAMESPACE + '.captionsvisible');
	}
};



// WEBPACK FOOTER //
// ./src/js/plugins/keyboard-navigation.js